import React, { FunctionComponent } from 'react'
import EMongoliaOtp from '@/components/page/emongoliaOtp'

interface Props {
  instanceId?: string
  onClick: (instance?: any) => void
}

const Step2: FunctionComponent<Props> = ({ instanceId, onClick }) => {
  return (
    <EMongoliaOtp
      instanceId={instanceId}
      service='newNumber'
      onComplete={onClick}
    />
  )
}
export default Step2
